module.exports = __webpack_public_path__ + "media/images/gm_icon03-b2479a2d78cd8978c7303a115431b6dd.png";